// Order-specific API helpers.
import { request } from './api';

export const ordersApi = {
    list: (params) => request('/orders', { params }),
    filters: () => request('/orders/filters'),
    get: (id) => request(`/orders/${id}`),
    patch: (id, body) => request(`/orders/${id}`, { method: 'PATCH', body }),
    assign: (id, call_center_id) => request(`/orders/${id}/assign`, { method: 'PATCH', body: { call_center_id } }),
    createWhatsapp: (body) => request('/orders/whatsapp', { method: 'POST', body }),
};
